var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLocationIconBold = function SvgLocationIconBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#403F3F",
    strokeWidth: 1.5,
    d: "M7.888 8.394c1.102 0 1.994-.873 1.994-1.95s-.892-1.95-1.994-1.95c-1.1 0-1.993.873-1.993 1.95s.892 1.95 1.993 1.95Z",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#403F3F",
    strokeWidth: 1.5,
    d: "M2.534 5.306C3.793-.106 11.992-.1 13.245 5.312c.735 3.176-1.284 5.863-3.055 7.526a3.373 3.373 0 0 1-4.608 0C3.82 11.175 1.8 8.48 2.534 5.306Z"
  })));
};
export default SvgLocationIconBold;